<template>
  <v-form ref="form" v-model="valid" class="search-form">
    <v-row no-gutters class="search">
      <v-col cols="12" sm="6" md="4" class="pa-4">
        <auto-select
          autofocus
          :menu-props="{ contentClass: 'text-left' }"
          name="patient"
          dense
          outlined
          v-model="patient"
          :items="patients"
          :item-text="(item) => patientText(item)"
          item-value="Id"
          return-object
          class="patient-input required"
          :rules="[$rules.required]"
          :label="$t('components.claims_history.header.patient')"
        ></auto-select>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="pa-4">
        <v-autocomplete
          class="coverage-input"
          name="coverages"
          :menu-props="{ contentClass: 'text-left benefits' }"
          dense
          :label="$t('components.claims_history.coverage_benefit')"
          v-model="benefit"
          :items="planBenefits"
          item-text="DisplayValue"
          item-value="Id"
          hide-details
          @input="(v) => $emit('benefit-selected', v)"
          clearable
          return-object
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutoSelect from "@/components/AutoSelect.vue";
export default {
  props: {
    patients: Array,
    planBenefits: Array,
  },
  components: {
    AutoSelect,
  },
  data() {
    return {
      valid: false,
      patient: null,
      benefit: null,
    };
  },
  watch: {
    patient: {
      handler(v) {
        this.$emit("patient-selected", v);
      },
      immediate: true,
    },
    patients: {
      handler(v) {
        if (v) {
          this.patient = v[0];
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.patients && this.patients.length) {
      this.patient = this.patients[0];
    }
  },
  methods: {
    patientText(item) {
      if (item.DateOfBirth === null || item.DateOfBirth === undefined) {
        return `${item.FirstName} ${item.LastName}`;
      }
      return `${item.FirstName} ${item.LastName} (${this.$helpers.formatDate(
        item.DateOfBirth
      )})`;
    },
  },
};
</script>
<style scoped>
.search-form {
  background-color: #eaeaea;
}
.patient-input > :not(.v-input--is-disabled) /deep/ fieldset {
  background-color: white;
}
.coverage-input > :not(.v-input--is-disabled) /deep/ fieldset {
  background-color: white;
}
</style>
